export default "__VITE_ASSET__IgTpY8tc__"